import * as React from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import ProtectedRoute from "./features/ProtectedRoute";
import Login from "./features/Login";
import ReportsPage from "./screens/ReportsPage";
import AllInstallationsPage from "./screens/AllInstallationsPage";
import AdminPage from "./screens/AdminPage";
// import RegistrationInformationPage from "./screens/RegistrationInformationPage";
import HomeScreen from "./screens/HomePage";
import InstallationPage from "./screens/InstallationPage";
import ForgotPassword from "./features/ForgotPassword";
import ResetPassword from "./features/ResetPassword";
import AcceptRegisterTerm from "./features/AcceptRegisterTerm";
import FaqPage from "./screens/FaqPage";
import RouteListener from "./features/RouteListener";
import EditAdminPage from "./screens/EditAdminPage";
import SearchUsersPage from "./screens/SearchUsersPage";
import SearchInstallationsPage from "./screens/SearchInstallationsPage";

import {
  PERMISSION_ACCESS_ADMIN,
  PERMISSION_ACCESS_BASE,
  PERMISSION_ACCESS_CONSUMPTION_CHART,
  PERMISSION_ACCESS_CONSUMPTION_HISTORY,
  PERMISSION_ACCESS_CONSUMPTION_REPORT,
  PERMISSION_ACCESS_INFORM_LEVEL,
  PERMISSION_ACCESS_LEVEL_CHART,
  PERMISSION_ACCESS_LEVEL_HISTORY,
  PERMISSION_ACCESS_LEVEL_REPORT,
  PERMISSION_ACCESS_ALL_INSTALLATIONS,
} from "./core/models/Permission";
import ToastrListener from "./features/ToastrListener";
import DialogListener from "./features/DialogListener";

function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <ProtectedRoute
          path="/home/"
          component={HomeScreen}
          permissionType={PERMISSION_ACCESS_BASE}
          title="Página inicial"
        />
        <ProtectedRoute
          path="/reports/:initial_tab?/"
          component={ReportsPage}
          permissionType={[PERMISSION_ACCESS_LEVEL_REPORT, PERMISSION_ACCESS_CONSUMPTION_REPORT]}
        />
        <ProtectedRoute
          exact
          path="/reports/level/"
          component={ReportsPage}
          permissionType={PERMISSION_ACCESS_LEVEL_REPORT}
          title="Relatório de Nível"
        />
        <ProtectedRoute
          exact
          path="/reports/consumption/"
          component={ReportsPage}
          permissionType={PERMISSION_ACCESS_CONSUMPTION_REPORT}
          title="Relatório de Consumo"
        />

        <ProtectedRoute
          exact
          path="/admin/"
          component={AdminPage}
          permissionType={PERMISSION_ACCESS_ADMIN}
          title="Página de Administrador"
        />
        <ProtectedRoute
          exact
          path="/all-installations/"
          component={AllInstallationsPage}
          permissionType={PERMISSION_ACCESS_ALL_INSTALLATIONS}
          title="Todas instalações"
        />
        <ProtectedRoute
          path="/faq/"
          component={FaqPage}
          permissionType={PERMISSION_ACCESS_BASE}
          title="FAQ"
        />
        {/* <ProtectedRoute path="/registration_info/" component={RegistrationInformationPage} /> */}

        <ProtectedRoute
          exact
          path="/installation/:customer_id?/:installation_id?/:initial_tab=level/"
          component={InstallationPage}
          permissionType={PERMISSION_ACCESS_LEVEL_CHART}
        />
        <ProtectedRoute
          exact
          path="/installation/:customer_id?/:installation_id?/:initial_tab=consumption/"
          component={InstallationPage}
          permissionType={PERMISSION_ACCESS_CONSUMPTION_CHART}
        />
        <ProtectedRoute
          exact
          path="/installation/:customer_id?/:installation_id?/:initial_tab=send_level/"
          component={InstallationPage}
          permissionType={PERMISSION_ACCESS_INFORM_LEVEL}
        />
        <ProtectedRoute
          exact
          path="/installation/:customer_id?/:installation_id?/:initial_tab?/"
          component={InstallationPage}
          permissionType={[
            PERMISSION_ACCESS_CONSUMPTION_CHART,
            PERMISSION_ACCESS_INFORM_LEVEL,
            PERMISSION_ACCESS_LEVEL_CHART,
            PERMISSION_ACCESS_LEVEL_HISTORY,
            PERMISSION_ACCESS_CONSUMPTION_HISTORY,
          ]}
        />
        <ProtectedRoute
          path="/admin/edit/:installation_group_id/"
          component={EditAdminPage}
          permissionType={PERMISSION_ACCESS_ADMIN}
          title="Edição de Grupo"
        />

        <ProtectedRoute
          path="/admin/new/"
          component={EditAdminPage}
          permissionType={PERMISSION_ACCESS_ADMIN}
          title="Adicionar novo grupo"
        />

        <ProtectedRoute
          exact
          path="/search/user/"
          component={SearchUsersPage}
          permissionType={PERMISSION_ACCESS_ADMIN}
          title="Buscar usuários"
        />

        <ProtectedRoute
          exact
          path="/search/installation/"
          component={SearchInstallationsPage}
          permissionType={PERMISSION_ACCESS_ADMIN}
          title="Buscar Instalação"
        />
        <Route exact path="/" component={Login} />

        <Route exact path="/login/">
          <Login expiredToken />
        </Route>

        <Route exact path="/forgot_password/" component={ForgotPassword} />
        <Route exact path="/reset/:token/:toastr?" component={ResetPassword} />
        <Route exact path="/accept_register_term/:token/" component={AcceptRegisterTerm} />
      </Switch>

      {/* Global Re-router */}
      <RouteListener />
      <ToastrListener />
      <DialogListener />
    </BrowserRouter>
  );
}

export default Routes;
